import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['modal', 'year1', 'year2', 'year3', 'year4', 'year1Images', 'year2Images', 'year3Images', 'year4Images']

  connect() {
    console.log('rollover_controller')
  }

  hoverin(event) {
    const copyTarget = event.currentTarget.dataset.year
    if (!copyTarget) return

    this[`${copyTarget}ImagesTargets`].forEach(e => e.setAttribute('filter', "url(#glow)"))
  }

  hoverout(event) {
    const copyTarget = event.currentTarget.dataset.year
    if (!copyTarget) return

    this[`${copyTarget}ImagesTargets`].forEach(e => e.setAttribute('filter', ""))
  }

  click(event) {
    const copyTarget = event.currentTarget.dataset.year
    if (!copyTarget) return

    this[`${copyTarget}Target`].classList.remove('hidden')
    this.modalTarget.classList.remove('hidden')
  }

  close() {
    this.modalTarget.classList.add('hidden')
    this.year1Target.classList.add("hidden")
    this.year2Target.classList.add("hidden")
    this.year3Target.classList.add("hidden")
    this.year4Target.classList.add("hidden")
  }
}
